<template>
    <button
        class="flex items-center justify-center cursor-pointer outline-none px-8 py-4 uppercase my-2"
    >
        <slot></slot>
    </button>
</template>
